export interface FooterLink {
  name: string;
  href: string;
}

export const LINKS: FooterLink[] = [
  {
    href: 'https://www.cisco.com/c/en/us/about/contact-cisco.html',
    name: 'Contacts',
  },
  {
    href: 'https://secure.opinionlab.com/ccc01/o.asp?id=jBjOhqOJ',
    name: 'Feedback',
  },
  {
    href: 'http://www.cisco.com/c/en/us/about/sitemap.html',
    name: 'Help',
  },
  {
    href: 'http://www.cisco.com/c/en/us/about/sitemap.html',
    name: 'Site Map',
  },
  {
    href: 'https://www.cisco.com/c/en/us/about/legal/terms-conditions.html',
    name: 'Terms & Conditions',
  },
  {
    href: 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html',
    name: 'Privacy Statement',
  },
  {
    href: 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html#cookies',
    name: 'Cookie Policy',
  },
  {
    href: 'https://www.cisco.com/c/en/us/about/legal/trademarks.html',
    name: 'Trademarks',
  },
];
